import { all } from 'redux-saga/effects';

import authSagas from './Auth/Auth.saga.js';
import dealsSaga from './Deals/deals.saga.js';
import agentSagas from './Agent/Agent.saga.js';
import phoneSagas from './Phone/Phone.saga.js';
import paymentSagas from './Payment/Payment.saga.js';
import campaignSagas from './Campaign/Campaign.saga.js';
import settingsSagas from './Settings/Settings.saga.js';
import assistantSagas from './Assistant/Assistant.saga.js';
import integrationSagas from './Integration/Integration.saga.js';
import activitiesSagas from './Activities/Activities.saga.js';
import singlePageSagas from './SinglePage/singlepage.saga.js';
import objectsSagas from './Objects/objects.saga.js';
import { workflowsSaga } from './Workflows/workflows.saga.js';
import adminSagas from './Admin/Admin.saga.js';
import dashboardSagas from './Dashboard/Dashboard.saga.js';
import notificationSagas from './Notification/Notification.saga.js';
export default function* rootSaga() {
  yield all([ authSagas(), campaignSagas(), integrationSagas(), agentSagas(), phoneSagas(), settingsSagas(), paymentSagas(), assistantSagas(), dealsSaga(), activitiesSagas(), singlePageSagas(), objectsSagas(), workflowsSaga(), adminSagas(), dashboardSagas(), notificationSagas() ]);
}